import { default as _91_46_46_46slug_93dchlEdxXKhMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/[...slug].vue?macro=true";
import { default as _404dWfuIwvJ2YMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/404.vue?macro=true";
import { default as indexhotg60CF2bMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/arbochecklist/index.vue?macro=true";
import { default as bedanktBSLwkQ0vBRMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/bedankt.vue?macro=true";
import { default as _91slug_93Zi8Y6jabkBMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/contact/[slug].vue?macro=true";
import { default as index7lU20ihht0Meta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/contact/index.vue?macro=true";
import { default as indexrsJLMqSYzCMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93qf5o12CBmoMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/nieuws/[slug].vue?macro=true";
import { default as indexm7pp2nR2aYMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/nieuws/index.vue?macro=true";
import { default as open_45sollicitatieM5GKVK0RQlMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/open-sollicitatie.vue?macro=true";
import { default as _91_46_46_46slug_93K073dbo8oXMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/over-westerduin/[...slug].vue?macro=true";
import { default as _91slug_93Sat4vdnfFPMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/referenties/[slug].vue?macro=true";
import { default as indexFyi48tWdKcMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/referenties/index.vue?macro=true";
import { default as vacatures_45als_45_91slug_93gYHIgpkXF5Meta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures-als-[slug].vue?macro=true";
import { default as vacatures_45bij_45_91slug_93ww6VrzCPupMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures-bij-[slug].vue?macro=true";
import { default as vacatures_45in_45_91slug_93stZ9GH9ko2Meta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures-in-[slug].vue?macro=true";
import { default as _91slug_93Q1DzbMDw9OMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures/[slug].vue?macro=true";
import { default as index688kwZgwRzMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures/index.vue?macro=true";
import { default as vragen7B1qS7dP6EMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vragen.vue?macro=true";
import { default as _91_46_46_46slug_932ajkY8IYEJMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/[...slug].vue?macro=true";
import { default as bedankthr4scW06R4Meta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/bedankt.vue?macro=true";
import { default as faqIgUyjMTVMbMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/faq.vue?macro=true";
import { default as registratie_45inlenersbeloningBECNubbckHMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue?macro=true";
import { default as werkwijze8ruSVZqzwFMeta } from "/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkwijze.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93dchlEdxXKhMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "arbochecklist",
    path: "/arbochecklist",
    meta: indexhotg60CF2bMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/arbochecklist/index.vue").then(m => m.default || m)
  },
  {
    name: "bedankt",
    path: "/bedankt",
    meta: bedanktBSLwkQ0vBRMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "contact-slug",
    path: "/contact/:slug()",
    meta: _91slug_93Zi8Y6jabkBMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/contact/[slug].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    meta: index7lU20ihht0Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexrsJLMqSYzCMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug()",
    meta: _91slug_93qf5o12CBmoMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/nieuws/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nieuws",
    path: "/nieuws",
    meta: indexm7pp2nR2aYMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/nieuws/index.vue").then(m => m.default || m)
  },
  {
    name: "open-sollicitatie",
    path: "/open-sollicitatie",
    meta: open_45sollicitatieM5GKVK0RQlMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/open-sollicitatie.vue").then(m => m.default || m)
  },
  {
    name: "over-westerduin-slug",
    path: "/over-westerduin/:slug(.*)*",
    meta: _91_46_46_46slug_93K073dbo8oXMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/over-westerduin/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties-slug",
    path: "/referenties/:slug()",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/referenties/[slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties",
    path: "/referenties",
    meta: indexFyi48tWdKcMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/referenties/index.vue").then(m => m.default || m)
  },
  {
    name: "vacatures-als-slug",
    path: "/vacatures-als-:slug()",
    meta: vacatures_45als_45_91slug_93gYHIgpkXF5Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures-als-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-bij-slug",
    path: "/vacatures-bij-:slug()",
    meta: vacatures_45bij_45_91slug_93ww6VrzCPupMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures-bij-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-in-slug",
    path: "/vacatures-in-:slug()",
    meta: vacatures_45in_45_91slug_93stZ9GH9ko2Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures-in-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-slug",
    path: "/vacatures/:slug()",
    meta: _91slug_93Q1DzbMDw9OMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures",
    path: "/vacatures",
    meta: index688kwZgwRzMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vacatures/index.vue").then(m => m.default || m)
  },
  {
    name: "vragen",
    path: "/vragen",
    meta: vragen7B1qS7dP6EMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/vragen.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-slug",
    path: "/werkgevers/:slug(.*)*",
    meta: _91_46_46_46slug_932ajkY8IYEJMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-bedankt",
    path: "/werkgevers/bedankt",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-faq",
    path: "/werkgevers/faq",
    meta: faqIgUyjMTVMbMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/faq.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-registratie-inlenersbeloning",
    path: "/werkgevers/registratie-inlenersbeloning",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue").then(m => m.default || m)
  },
  {
    name: "werkwijze",
    path: "/werkwijze",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/24/nuxt/pages/werkwijze.vue").then(m => m.default || m)
  }
]